"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidParameter = void 0;

var _constants = require("../validation/constants");

/**
 * @desc
 * Determines if there is a notifications with given namespace and error type. If there, it means the parameter is not valid.
 *
 * @public
 * @function
 *
 * @param   {string}    namespace   - Namespace of control to be checked.
 * @param   {object}    notifications  - .
 * @returns {boolean}   *           - True if given parameter is valid, False if not.
 */
var isValidParameter = function isValidParameter(namespace, notifications) {
  var hasErrors = notifications.some(function (notification) {
    return notification.namespace === namespace && notification.severity === _constants.ALERT_TYPE_ERROR;
  });
  return !hasErrors;
};

exports.isValidParameter = isValidParameter;
//# sourceMappingURL=is-valid-parameter.js.map